/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavMissionsReportDay
 */
export interface OutputUavMissionsReportDay {
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionsReportDay
     */
    date: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionsReportDay
     */
    flights: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionsReportDay
     */
    requests: number;
}

/**
 * Check if a given object implements the OutputUavMissionsReportDay interface.
 */
export function instanceOfOutputUavMissionsReportDay(value: object): boolean {
    if (!('date' in value)) return false;
    if (!('flights' in value)) return false;
    if (!('requests' in value)) return false;
    return true;
}

export function OutputUavMissionsReportDayFromJSON(json: any): OutputUavMissionsReportDay {
    return OutputUavMissionsReportDayFromJSONTyped(json, false);
}

export function OutputUavMissionsReportDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMissionsReportDay {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'],
        'flights': json['flights'],
        'requests': json['requests'],
    };
}

export function OutputUavMissionsReportDayToJSON(value?: OutputUavMissionsReportDay | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'date': value['date'],
        'flights': value['flights'],
        'requests': value['requests'],
    };
}

